import { Score } from "@keita/lanepatrol-sdk";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  CreateHlaForecastScenarioRequest,
  HlaForecastScenario,
  UpdateHlaForecastScenarioRequest,
} from "../models/HlaForecastScenario";
import { CalculateHlaScore } from "../models/CalculateHlaScore";

const apiPrefix = "/hla-forecast";
export const HlaForecastApi = {
  create: async (request: CreateHlaForecastScenarioRequest) => {
    return await jwtAuthAxios().post<HlaForecastScenario>(apiPrefix, request);
  },

  update: async (id: string, request: UpdateHlaForecastScenarioRequest) => {
    return await jwtAuthAxios().put<HlaForecastScenario>(
      `${apiPrefix}/${id}`,
      request,
    );
  },

  delete: async (id: string) => {
    return await jwtAuthAxios().delete(`${apiPrefix}/${id}`);
  },

  simulateScores: async (request: CalculateHlaScore) => {
    return await jwtAuthAxios().post<Score[]>(
      `${apiPrefix}/calculate-scores`,
      request,
    );
  },
};
